<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 17:40:42
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:47:59
 * @name: 部门编辑
 * @Description: 部门编辑
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\dialog\edit-department.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <addNeditDialog
    ref="addNeditDialog"
    title="编辑部门"
    bar-title="部门信息"
    @close="close"
  >
    <template v-slot:form>
      <div class="line">
        <font class="label"><i class="warn">*</i>部门名称:</font>
        <el-input
          class="input"
          v-model="name"
          placeholder="请输入部门名称"
        ></el-input>
      </div>
      <div class="line">
        <font class="label">上级部门:</font>
        <el-select class="input" v-model="parent_id">
          <el-option
            v-for="item of parents"
            :key="item.id"
            :label="item.department_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="line">
        <font class="label">总人数:</font>
        <font>{{ mailList.treeNode.department_user_count }}人</font>
      </div>
    </template>
    <template v-slot:btnGroup>
      <el-button type="primary" @click="save">保存</el-button>
      <el-button type="danger" plain @click="del">删除</el-button>
      <el-button plain @click="cancel">取消</el-button>
    </template>
  </addNeditDialog>
</template>
<script>
import { confirmation, debounceation } from "@/utils/decorator";
import addNeditDialog from "./addNeditDialog";
export default {
  name: "mailList-Content-editDepartment",
  components: {
    addNeditDialog,
  },
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      department_id: "", //部门id
      name: "", //部门名称
      parent_id: "", //上级部门id
      parents: [], //部门列表
    };
  },
  computed: {
    // 验证部门名称是否已填
    name_match() {
      return this.name === "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开dialog
     */
    open() {
      let { all, me } = this.mailList.getAllNodeNnow(); //获取所有部门及当前部门
      all.splice(
        all.findIndex((x) => x.id === me),
        1
      ); //将自己剔除
      this.department_id = me;
      this.name = this.mailList.treeNode.department_name;
      this.parents = all;
      this.parent_id = this.mailList.getParent(me).id;
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击保存
     */
    @confirmation("确认提交修改?")
    save() {
      this.mailList
        .editItem({
          id: this.department_id,
          name: this.name,
          parent_id: this.parent_id,
        })
        .then((res) => {
          this.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击删除
     */
    @confirmation("确认删除?")
    del() {
      this.mailList
        .deleteItem({
          id: Number(this.department_id),
        })
        .then((res) => {
          this.cancel();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击取消
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化
     */
    close() {
      this.department_id = "";
      this.name = "";
      this.parent_id = "";
      this.parents = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 400px;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
}
.el-button {
  margin-left: 40px;
  width: $Var-button-width-normal;
  &:first-child {
    margin-left: 0;
  }
}
</style>
